import { __assign as t } from "./index67.mjs";
import { WHITE_SPACE_REGEX as v } from "./index68.mjs";
function R(i) {
  if (i.length === 0)
    throw new Error("Number skeleton cannot be empty");
  for (var n = i.split(v).filter(function(u) {
    return u.length > 0;
  }), o = [], r = 0, e = n; r < e.length; r++) {
    var m = e[r], l = m.split("/");
    if (l.length === 0)
      throw new Error("Invalid number skeleton");
    for (var f = l[0], a = l.slice(1), c = 0, g = a; c < g.length; c++) {
      var s = g[c];
      if (s.length === 0)
        throw new Error("Invalid number skeleton");
    }
    o.push({ stem: f, options: a });
  }
  return o;
}
function I(i) {
  return i.replace(/^(.*?)-/, "");
}
var h = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, w = /^(@+)?(\+|#+)?[rs]?$/g, S = /(\*)(0+)|(#+)(0+)|(0+)/g, D = /^(0+)$/;
function d(i) {
  var n = {};
  return i[i.length - 1] === "r" ? n.roundingPriority = "morePrecision" : i[i.length - 1] === "s" && (n.roundingPriority = "lessPrecision"), i.replace(w, function(o, r, e) {
    return typeof e != "string" ? (n.minimumSignificantDigits = r.length, n.maximumSignificantDigits = r.length) : e === "+" ? n.minimumSignificantDigits = r.length : r[0] === "#" ? n.maximumSignificantDigits = r.length : (n.minimumSignificantDigits = r.length, n.maximumSignificantDigits = r.length + (typeof e == "string" ? e.length : 0)), "";
  }), n;
}
function E(i) {
  switch (i) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function x(i) {
  var n;
  if (i[0] === "E" && i[1] === "E" ? (n = {
    notation: "engineering"
  }, i = i.slice(2)) : i[0] === "E" && (n = {
    notation: "scientific"
  }, i = i.slice(1)), n) {
    var o = i.slice(0, 2);
    if (o === "+!" ? (n.signDisplay = "always", i = i.slice(2)) : o === "+?" && (n.signDisplay = "exceptZero", i = i.slice(2)), !D.test(i))
      throw new Error("Malformed concise eng/scientific notation");
    n.minimumIntegerDigits = i.length;
  }
  return n;
}
function y(i) {
  var n = {}, o = E(i);
  return o || n;
}
function G(i) {
  for (var n = {}, o = 0, r = i; o < r.length; o++) {
    var e = r[o];
    switch (e.stem) {
      case "percent":
      case "%":
        n.style = "percent";
        continue;
      case "%x100":
        n.style = "percent", n.scale = 100;
        continue;
      case "currency":
        n.style = "currency", n.currency = e.options[0];
        continue;
      case "group-off":
      case ",_":
        n.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        n.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        n.style = "unit", n.unit = I(e.options[0]);
        continue;
      case "compact-short":
      case "K":
        n.notation = "compact", n.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        n.notation = "compact", n.compactDisplay = "long";
        continue;
      case "scientific":
        n = t(t(t({}, n), { notation: "scientific" }), e.options.reduce(function(a, c) {
          return t(t({}, a), y(c));
        }, {}));
        continue;
      case "engineering":
        n = t(t(t({}, n), { notation: "engineering" }), e.options.reduce(function(a, c) {
          return t(t({}, a), y(c));
        }, {}));
        continue;
      case "notation-simple":
        n.notation = "standard";
        continue;
      // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
      case "unit-width-narrow":
        n.currencyDisplay = "narrowSymbol", n.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        n.currencyDisplay = "code", n.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        n.currencyDisplay = "name", n.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        n.currencyDisplay = "symbol";
        continue;
      case "scale":
        n.scale = parseFloat(e.options[0]);
        continue;
      case "rounding-mode-floor":
        n.roundingMode = "floor";
        continue;
      case "rounding-mode-ceiling":
        n.roundingMode = "ceil";
        continue;
      case "rounding-mode-down":
        n.roundingMode = "trunc";
        continue;
      case "rounding-mode-up":
        n.roundingMode = "expand";
        continue;
      case "rounding-mode-half-even":
        n.roundingMode = "halfEven";
        continue;
      case "rounding-mode-half-down":
        n.roundingMode = "halfTrunc";
        continue;
      case "rounding-mode-half-up":
        n.roundingMode = "halfExpand";
        continue;
      // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
      case "integer-width":
        if (e.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        e.options[0].replace(S, function(a, c, g, s, u, p) {
          if (c)
            n.minimumIntegerDigits = g.length;
          else {
            if (s && u)
              throw new Error("We currently do not support maximum integer digits");
            if (p)
              throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (D.test(e.stem)) {
      n.minimumIntegerDigits = e.stem.length;
      continue;
    }
    if (h.test(e.stem)) {
      if (e.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      e.stem.replace(h, function(a, c, g, s, u, p) {
        return g === "*" ? n.minimumFractionDigits = c.length : s && s[0] === "#" ? n.maximumFractionDigits = s.length : u && p ? (n.minimumFractionDigits = u.length, n.maximumFractionDigits = u.length + p.length) : (n.minimumFractionDigits = c.length, n.maximumFractionDigits = c.length), "";
      });
      var m = e.options[0];
      m === "w" ? n = t(t({}, n), { trailingZeroDisplay: "stripIfInteger" }) : m && (n = t(t({}, n), d(m)));
      continue;
    }
    if (w.test(e.stem)) {
      n = t(t({}, n), d(e.stem));
      continue;
    }
    var l = E(e.stem);
    l && (n = t(t({}, n), l));
    var f = x(e.stem);
    f && (n = t(t({}, n), f));
  }
  return n;
}
export {
  G as parseNumberSkeleton,
  R as parseNumberSkeletonFromString
};
